import {
	createHashRouter,
	RouterProvider,
} from "react-router-dom";
import { Home, Unsubscribe, Ambassador, FormPage } from './pages'
import { CookieConsent } from './components';
import { ModalProvider } from './context/ModalContext';

const router = createHashRouter([
	{
		path: "/",
		element: <Home />,
	},
	{
		path: "/v2",
		element: <Home />,
	},
	{
		path: "/redesign",
		element: <Home />,
	},
	{
		path: "/unsubscribe",
		element: <Unsubscribe />,
	},
	{
		path: "/ambassador",
		element: <Ambassador />,
	},
	{
		path: "/ambassador/reset-password/:token",
		element: <Ambassador />,
	},
	{
		path: "/ambasador",
		element: <Ambassador />,
	},
	{
		path: "/ambasador/reset-password/:token",
		element: <Ambassador />,
	},
	{
		path: "/reset-password/:token",
		element: <Ambassador />,
	},
	// CamelCase variants
	{
		path: "/ambassador/resetPassword/:token",
		element: <Ambassador />,
	},
	{
		path: "/resetPassword/:token",
		element: <Ambassador />,
	},
	// Token-less fallbacks
	{
		path: "/reset-password",
		element: <Ambassador />,
	},
	{
		path: "/resetPassword",
		element: <Ambassador />,
	},
	{
		path: "/:form_slug",
		element: <FormPage />,
	},
]);

// Handle direct navigation to /ambassador
if (typeof window !== 'undefined' && window.location.pathname === '/ambassador') {
	window.location.replace('/#/ambassador');
}

export default function App() {
	// UNCOMMENT THE LINE BELOW TO SIMULATE A CRASH:
	// throw new Error('Simulation of valoare error on main site');

	return (
		<div id="App">
			<ModalProvider>
				<RouterProvider router={router} />
				<CookieConsent />
			</ModalProvider>
		</div>
	)
}
